export default __webpack_public_path__ + "static/media/india_agriculture_forecast.dac920815b14464f1f5bf34506ad136f.png";